import React, { useState } from "react";
import { Button, Space, Typography } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { updateVisit } from "../network/api";
import { notify, serverError } from "../utils/notify";

const { Text } = Typography;

// D5 — capture the technician's geolocation on the visit.
export default function GeoCapture({ visit, canEdit, onChange }) {
  const [busy, setBusy] = useState(false);
  const geo = visit.geo;

  const capture = () => {
    if (!navigator.geolocation) return notify.warning("Geolocation isn't available on this device");
    setBusy(true);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          await updateVisit(visit._id, { geo: { lat: pos.coords.latitude, lng: pos.coords.longitude } });
          notify.success("Location captured");
          onChange?.();
        } catch (e) {
          notify.error(serverError(e, "Failed to save location"));
        } finally {
          setBusy(false);
        }
      },
      (err) => {
        notify.error(`Couldn't get location: ${err.message}`);
        setBusy(false);
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  return (
    <Space wrap size={8}>
      {geo?.lat != null ? (
        <Text>
          <EnvironmentOutlined /> {geo.lat.toFixed(5)}, {geo.lng.toFixed(5)}{" "}
          <a href={`https://maps.google.com/?q=${geo.lat},${geo.lng}`} target="_blank" rel="noreferrer">map</a>
        </Text>
      ) : (
        <Text type="secondary">Not captured</Text>
      )}
      {canEdit && (
        <Button size="small" icon={<EnvironmentOutlined />} loading={busy} onClick={capture}>
          {geo?.lat != null ? "Update" : "Capture location"}
        </Button>
      )}
    </Space>
  );
}
